import { ElectronApi } from '@/services/electron.api';
import { Description } from '@/types/watchface';
import { getProtocol } from './getProtocol';
import { getImageFmt } from './getImageFmt';
import { getResolution } from './getResolution';
import { getRegions } from './getRegion';
import { getCompress } from './getCompress';
import { getDataSource } from './getDataSource';
import { getValue } from './getValue';
import { CapabilityJson, getCapabilitySetJson } from './getCapabilitySetJson';
import { testAccess } from '../fs/fs-extra.utils';

/**
 * 写入能力集JSON文件
 * @param description
 * @param watchfaceAst
 * @returns 能力集文件
 */
export const writeCapabilitySet = async (
  des: Description,
  watchfaceAst: Ast,
  watchPath: string
) => {
  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  if (!fs || !path || !des) return;
  const capabilitySetPath = path.join(watchPath, 'capability.json');
  try {
    const capabilityWholeSet = await getCapabilitySetJson();
    const capabilitySet = getCapability(des, watchfaceAst, capabilityWholeSet);
    const capabilitySetJson = JSON.stringify(capabilitySet, null, '\t');
    await fs.promises.writeFile(capabilitySetPath, capabilitySetJson, 'utf-8');
    return capabilitySetPath;
  } catch (error) {
    // 发生错误，则清理历史文件
    console.error('生成能力集文件错误', error);
    if (await testAccess(capabilitySetPath))
      await fs.promises.rm(capabilitySetPath);
  }
};

const getCapability = (
  des: Description,
  watchfaceAst: Ast,
  capabilityWholeSet: CapabilityJson
) => {
  const size = getSize(des.size);
  const resAst = watchfaceAst.children[0];

  // 获取协议中分辨率值，如果未获取到，代表不支持能力集
  const resolution = getResolution(capabilityWholeSet, size);
  if (!resolution) throw '该设备不支持能力集，无法生成';
  const protocol = getProtocol(watchfaceAst, des);
  const region = getRegions();

  const image_compress_list = getCompress(watchfaceAst);
  const image_fmt_list = getImageFmt(resAst);
  const data_source_list = getDataSource(resAst);
  const image_compress = getValue(
    'image_compress',
    image_compress_list,
    capabilityWholeSet
  );
  const image_fmt = getValue('image_fmt', image_fmt_list, capabilityWholeSet);
  const data_source = getValue(
    'data_source',
    data_source_list,
    capabilityWholeSet
  );
  const capabilitySet = [
    {
      name: 'protocol',
      type: 1,
      value: [protocol]
    },
    {
      name: 'resolution',
      type: 2,
      value: [resolution]
    },
    {
      name: 'region',
      type: 2,
      value: region
    },
    {
      name: 'packet',
      type: 2,
      value: ['BIN']
    },
    {
      name: 'image_compress',
      type: 3,
      value: image_compress
    },
    {
      name: 'image_fmt',
      type: 3,
      value: image_fmt
    },
    {
      name: 'data_source',
      type: 3,
      value: data_source
    }
  ];
  return capabilitySet;
};

const getSize = (size: string) => {
  return size.replace('x', '*');
};
